{
  "features": {
    "config": {
      "title": "Partenaire de l'Agneau",
      "subtitle": "Configuration de l'intégration Twitch",
      "sections": {
        "premiumSkins": {
          "title": "Apparences premium",
          "description": "Grâce à cette extension, les spectateurs auront la possibilité d'apparaître dans le jeu sous la forme d'adeptes. Ils pourront personnaliser leurs personnages en utilisant des Bits contre des apparences premium. À vous de déterminer le prix de ces apparences. Vous pouvez également choisir de les rendre gratuites pour permettre à tout le monde de les utiliser librement.",
          "noBitsOption": "Rendre les apparences premium gratuites",
          "bitsFeatureNotAvailable": "Votre chaîne ne peut pas utiliser de Bits. Vos spectateurs pourront utiliser les apparences librement."
        }
      },
      "actions": {
        "save": "Enregistrer modifications"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "Rejoignez le culte de : {{channelName}} !",
        "subtitle": "Vous avez gagné le tirage !",
        "timeRemaining": "Temps restant : {{time}}",
        "message": "Rejoindre notre culte présente de nombreux avantages : la chance de vivre l'expérience unique d'une transformation démoniaque, l'honneur de dédier chaque seconde de votre vie au culte de l'Agneau tout-puissant, et, un jour peut-être, la gloire apportée par votre sacrifice !",
        "viewerLinkCta": "Veuillez d'abord {partager votre identité}.",
        "actions": {
          "joinRaffle": "Je veux rejoindre le culte",
          "joinRaffleViewerHasAlreadyJoined": "Vous participez au tirage",
          "dismissRaffle": "Non merci",
          "dismissRaffleViewerHasAlreadyJoined": "Fermer"
        },
        "raffleJoinedMessage": "Vos intentions sont louables. Vous saurez bientôt si vous rejoindrez le culte. Vous pouvez fermer cette fenêtre."
      },
      "followerBuilder": {
        "title": "Créer votre adepte",
        "steps": {
          "intro": {
            "message": "Vous avez rejoint le culte ! L'adepte que vous allez créer apparaîtra dans le jeu. Bien sûr, votre adepte mourra un jour, mais il aura servi une grande cause !",
            "actions": {
              "goToNextStep": "Créer votre adepte"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "Continuer"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "Retour aux apparences",
              "goToNextStep": {
                "variationsForSkin": "Continuer",
                "noVariationsForSkin": "Créer mon adepte"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "Retour aux couleurs",
              "goToNextStep": "Créer mon adepte"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "aider",
      "hinder": "entraver",
      "hhVotingFlyout": {
        "title": "Aider ou entraver",
        "message": "Votez",
        "timeRemaining": "Temps restant : {{time}}",
        "voteCount": "{{amount}} votes"
      },
      "outcomeVotingFlyout": {
        "title": "Votez pour {{helpOrHinder}} {{channelName}}",
        "timeRemaining": "Temps restant : {{time}}"
      }
    }
  }
}
